import { render, staticRenderFns } from "./VFatherProAnamCA.vue?vue&type=template&id=c53d096e"
import script from "./VFatherProAnamCA.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports